// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import "flatpickr"
import 'flatpickr/dist/l10n/ja.js'
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import 'bootstrap'
import toastr from 'toastr'
import '@fortawesome/fontawesome-free/js/all'
import '../stylesheets/application'
import '../stylesheets/payment/style'

Rails.start()
Turbolinks.start()
ActiveStorage.start()

window.toastr = toastr

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

require('packs/datepicker')
require('packs/expense')
require('packs/machine_error_history')
require('packs/machine')
require('packs/multi-select')
require('packs/payment_fee_rate')
require('packs/room_monitor_with_server')
require('packs/room_monitor')
require('packs/sales_amount')
require('packs/user')
require('packs/write_chart')
